import React from 'react';
import { OverlayTooltip, Placement } from '../../overlay';
import Button from '../button';
import { BulkElementConfiguration } from './bulk-action.type';
import ImageIcon from '../../../../components/images/image-icon';
import Icon from '../icon';

type IProps = {
  data: BulkElementConfiguration[];
};

const BulkAction: React.FC<IProps> = ({ data }) => {
  const renderButton = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    index,
    disabled,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Top}>
          <Button key={index} {...actionConfiguration} disabled={disabled}>
            {' '}
            {label}
          </Button>
        </OverlayTooltip>
      );
    }
    return (
      <Button key={index} {...actionConfiguration} disabled={disabled}>
        {' '}
        {label}
      </Button>
    );
  };

  const renderIcon = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    className,
    index,
    disabled,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Bottom}>
          <div
            key={index}
            className={`bulk-action-image-icon ${className}`}
            {...actionConfiguration}
            disabled={disabled}
          />
        </OverlayTooltip>
      );
    }
    return (
      <ImageIcon
        {...actionConfiguration}
        src={actionConfiguration.icon}
        disabled={disabled}
      />
    );
  };

  const renderIconButton = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    className,
    index,
    disabled,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Bottom}>
          <Button
            iconOnly={<Icon identifier={actionConfiguration.icon} />}
            key={index}
            className={`bulk-action-icon-button ${className} ${
              disabled ? 'disabled' : ''
            }`}
            {...actionConfiguration}
            disabled={disabled}
          />
        </OverlayTooltip>
      );
    }
    return (
      <Button
        iconOnly={<Icon identifier={actionConfiguration.icon} />}
        key={index}
        className={`bulk-action-icon-button ${className} ${
          disabled ? 'disabled' : ''
        }`}
        disabled={disabled}
        {...actionConfiguration}
      />
    );
  };

  const createComponent = (
    {
      renderComponent,
      label,
      actionConfiguration,
      popoverText,
      shouldShowPopover,
      className,
      disabled,
    }: BulkElementConfiguration,
    index,
  ) => {
    switch (renderComponent) {
      case 'Custom':
        return actionConfiguration?.component || <></>;
      case 'Button':
        return renderButton(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          index,
          disabled,
        );
      case 'Icon':
        return renderIcon(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          className,
          index,
          disabled,
        );
      case 'IconButton':
        return renderIconButton(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          className,
          index,
          disabled,
        );

      default:
        break;
    }

    return null;
  };

  return (
    <>
      {data.map((item: BulkElementConfiguration, index) =>
        createComponent(item, index),
      )}
    </>
  );
};

export default BulkAction;
